(function (upp) {
    'use strict';

    var $OPT_KEY = 'eshop';

    //Controller for template "/modules/eshop/eshop-promotions-products-catalog.html", url "/eshop/"
    //Delegates on controller: upp.plugins.products.CatalogCtrl
    upp.controller('upp.eshop.CatalogCtrl', ['$scope', 'eShopService', 'appi',
        function ($scope, eShopService, appi) {
            appi.ui.changeActualOption({moduleKey2Display: $OPT_KEY, navbarKey: $OPT_KEY});

            $scope.infiniteScroll = true;
            $scope.listProducts = eShopService.listEshopProducts;
        }]);

    //Controller for template "/modules/eshop/eshop-product.html", url "/eshop/{productDesc}-{productId}"
    //Delegates on controller: upp.plugins.products.ProductCtrl
    upp.controller('upp.eshop.ProductCtrl', ['$scope', '$routeParams', 'appi', 'eShopService', '$injector', '$sce', '$window', 'cartService',
        function ($scope, $routeParams, appi, eShopService, $injector, $sce, $window, cartService) {
            appi.ui.changeActualOption({moduleKey2Display: $OPT_KEY, navbarKey: $OPT_KEY}, function() {
                $window.history.back();
            });
            appi.ui.showPageLoadingMsg();

            // Set the default amount to 1
            $scope.amount = 1;
            $scope.selectedVariation = {};
            $scope.product = {};

            /**
             * check we have a concrete selection and an amount so we can add to cart
             * @returns boolean
             */
            $scope.checkAdd2cart = function() {
                return $scope.selectedVariation && $scope.selectedVariation.id && $scope.product.selectedStock > 0;
            };

            var productId = appi.utils.getIdFromParams($routeParams.info);

            var params = $window.getQueryParams(),
                mockProduct = params && params.mockProduct && Number(productId) === 0;

            if (!mockProduct) {
                eShopService.getEshopProduct(productId)
                    .then(function (data) {
                        if (data.product && data.product.description) {
                            data.product.description = $sce.trustAsHtml(data.product.description);
                        }
                        $scope.product = data.product;
                        $scope.currency = data.currency;
                        $scope.loaded = true;
                        appi.ui.hidePageLoadingMsg();
                    }, function () {
                        appi.ui.showNetworkError();
                    });
            } else {
                appi.ui.hidePageLoadingMsg();
                $scope.loaded = true;

                $scope.currency = {
                    code: 'EUR',
                    display: '&euro;',
                    id: 1,
                    name: 'Euro'
                };
                
                $scope.product = {
                    id: 0,
                    brand: null,
                    attributes: [],
                    category: null,
                    description: '',
                    files: [],
                    addToBasket: false,
                    name: '',
                    preview: '',
                    price: null,
                    promotions: [],
                    tags: []
                };
            }

            /**
             * Check if the selected product has valid stock comparing the current order for the client
             *
             * @returns {boolean} return true if is valid stock, otherwise false
             */
            $scope.checkStockAvailable = function() {
                var currentProduct = $scope.product;
                var cartProducts = cartService.getOrder().products;

                // Search the cart for current product instances
                var cartProduct = cartProducts.find(function(elem){
                    return elem.id == currentProduct.id &&
                        elem.selectedVariation.id == $scope.selectedVariation.id;
                });

                // We didnt find any product like this at the cart or we have stock available
                $scope.showNoStockAvailable = cartProduct != null && cartProduct.selectedVariation.stock != -1 && currentProduct.selectedStock > cartProduct.selectedVariation.stock - cartProduct.selectedStock;
                return !$scope.showNoStockAvailable;
            };

            $scope.add2cart = function (product, selectedVariation) {
                product.selectedVariation = selectedVariation;
                product.price = selectedVariation.price;
                var notify = cartService.add(product, $scope.currency);
                //show the notification
                notify();
                //reset selector
                product.selectedStock = 0;
            };

            $scope.getPriceSelected = function() {
                if ($scope.selectedVariation && $scope.selectedVariation.id)
                    return $scope.selectedVariation.price;
                else
                    return $scope.product.price;
            };

            $scope.getPriceFinalSelected = function() {
                if ($scope.selectedVariation && $scope.selectedVariation.id)
                    return $scope.selectedVariation.priceFinal;
                else
                    return $scope.product.priceFinal;
            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/eshop/controllers/eshop-controllers.js